import { useMutation } from "react-query";
import { useGlobalToast } from "components/GlobalToastProvider";
import { scheduleVideoCallAsync } from "api/appointments";

const useScheduleVideoCall = (options = {}) => {
  const { onError = () => {}, ...otherOptions } = options;
  const { showToast } = useGlobalToast();

  const { mutate, isLoading } = useMutation((payload) => scheduleVideoCallAsync(payload), {
    onError: () => {
      showToast({
        message: "Error scheduling appointment",
        errorState: true,
      });
      onError();
    },
    ...otherOptions,
  });

  return {
    scheduleVideoCall: mutate,
    isScheduleVideoCallLoading: isLoading,
  };
};

export default useScheduleVideoCall;
